import { ReactNode } from "react";
import { isBefore } from "date-fns/isBefore";
import { GameProvider } from "@looksrare/uikit";
import { ChainId } from "@looksrare/config";
import { LaserBlastConfig } from "@looksrare/classic-games/laser-blast";
import { useAccount } from "wagmi";
import { useGlobalSettings } from "@/hooks";
import { gameAddresses } from "@/config";
import { useUser } from "@/queries/user";

export const LaserBlastGameProvider = ({ children }: { children: ReactNode }) => {
  const { address } = useAccount();
  const { data: user } = useUser(address!, { enabled: !!address });

  const isSoundEnabled = useGlobalSettings((state) => state.isSoundEnabled);
  return (
    <GameProvider<LaserBlastConfig>
      supportedNetworks={["blast"]}
      addresses={gameAddresses}
      fallbackChainId={ChainId.BLAST_MAINNET}
      widgetBotOptions={{
        server: "1204359490925764680",
        channel: "1247425055433035868",
        shard: "https://emerald.widgetbot.io",
        glyph: ["/images/win/chat.png", "32px"],
        color: "#CCFD07",
        notifications: false,
        indicator: true,
      }}
      config={{
        isSoundEnabled,
        isWalletBlocked: !!user?.selfTimeoutUntil && isBefore(Date.now(), user?.selfTimeoutUntil),
        selfTimeoutUntil: user?.selfTimeoutUntil,
        supportedCurrencies: ["ETH", "YOLO"],
        points: {
          enabled: false,
        },
      }}
    >
      {children}
    </GameProvider>
  );
};
